// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"b294645d","826":"99ab53be"}[chunkId] + ".chunk.css";
};